import { render, staticRenderFns } from "./Quick.vue?vue&type=template&id=804b300a&scoped=true&"
import script from "./Quick.vue?vue&type=script&lang=js&"
export * from "./Quick.vue?vue&type=script&lang=js&"
import style0 from "./Quick.vue?vue&type=style&index=0&id=804b300a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804b300a",
  null
  
)

export default component.exports